export const Types = {
  TOGGLE_SUPPLIER_ID: 'STIX/TOGGLE_SUPPLIER_ID',
  CHANGE_REDEMPTION_POINTS: 'STIX/CHANGE_REDEMPTION_POINTS',
  CHANGE_MINIMUM_REDEMPTION_LIMIT: 'STIX/CHANGE_MINIMUM_REDEMPTION_LIMIT',
  CHANGE_MAXIMUM_REDEMPTION_LIMIT: 'STIX/CHANGE_MAXIMUM_REDEMPTION_LIMIT'
}

export const toggleSupplierId = supplierId => ({
  type: Types.TOGGLE_SUPPLIER_ID,
  supplierId
})

export const changeRedemptionPoints = redemptionPoints => ({
  type: Types.CHANGE_REDEMPTION_POINTS,
  redemptionPoints
})

export const changeMinimumRedemptionLimit = minimumRedemptionLimit => ({
  type: Types.CHANGE_MINIMUM_REDEMPTION_LIMIT,
  minimumRedemptionLimit
})

export const changeMaximumRedemptionLimit = maximumRedemptionLimit => ({
  type: Types.CHANGE_MAXIMUM_REDEMPTION_LIMIT,
  maximumRedemptionLimit
})

export default {
  toggleSupplierId,
  changeRedemptionPoints,
  changeMinimumRedemptionLimit,
  changeMaximumRedemptionLimit
}



// WEBPACK FOOTER //
// ./src/features/Stix/actions.js